<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <suspensao
      :activator="false"
      :permission="permission"
      model="Contrato"
      :item="contratoSuspensao"
      ref="suspensao"
    >
    </suspensao>
    <div class="mt-4">
      <v-card-text
        ><div class="pt-4 float-right">
          <v-dialog v-model="dialog_indicadores" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="canList"
                color="primary"
                dark
                class="ml-2 mb-2"
                v-on="on"
                >Indicadores</v-btn
              >
            </template>
            <indicadores
              :headers="headers"
              :localStorageKey="LOCAL_STORAGE_ID.headers"
              @save="_saveHeaders"
              @close="closeIndicadores"
            />
          </v-dialog>
        </div>
        <v-tabs icons-and-text v-model="tab">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#ativos" @click="handleGetContratos(true)">Ativos</v-tab>
          <v-tab href="#inativos" @click="handleGetContratos(false)"
            >Inativos</v-tab
          >

          <v-tabs-items v-model="tab">
            <v-tab-item value="ativos">
              <v-card-title>
                Filtro
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headersComputed"
                :items="items"
                :server-items-length="contratos"
                class="border"
                :options.sync="options"
                @update:options="handleGetContratos(true)"
                :item-class="suspendido"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Contratos registrados</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-icon
                      v-if="canList"
                      medium
                      @click="handleGetContratos(true)"
                      title="Atualizar"
                      >mdi-refresh</v-icon
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-switch
                      v-model="showPesagens"
                      label="Mostrar pesagens"
                      class="pa-3 mt-5"
                    ></v-switch>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog
                      v-model="dialog"
                      max-width="1000px"
                      v-if="podeAdicionar"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="canCreate"
                          color="primary"
                          dark
                          class="mb-2"
                          v-on="on"
                          @click="adicionarContrato"
                          >Novo</v-btn
                        >
                      </template>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.data_inicio`]="{ item }">
                  {{ item.data_inicio | date2br }}
                </template>
                <template v-slot:[`item.data_fim`]="{ item }">
                  {{ item.data_fim | date2br }}
                </template>
                <template
                  v-slot:[`item.quantidade_restante_agendamento`]="{ item }"
                >
                  {{ item | quantidade_restante_agendamento }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        class="mr-2 mb-2"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div>
                        <v-list-item
                          class="pointer"
                          v-if="
                            !item.suspendido &&
                            valido &&
                            !inativo(item) &&
                            (!item.contrato_pai ||
                              (item.contrato_pai &&
                                !item.contrato_pai.suspendido))
                          "
                          @click="handleAgendar(item)"
                          >Agendar</v-list-item
                        >
                        <v-list-item class="pointer" @click="exportarCsv(item)"
                          >Exportar csv</v-list-item
                        >
                        <v-list-item
                          class="pointer"
                          @click="detalhesDistribuicao(item)"
                          >Detalhes</v-list-item
                        >
                        <v-list-item
                          v-if="canUpdate && podeEditar && !item.transportadora"
                          class="pointer"
                          @click="() => handleEditar(item)"
                          >Editar</v-list-item
                        >
                        <v-list-item
                          v-if="podeDistribuir && canDistribuirTransportadora"
                          class="pointer"
                          @click="
                            () => handleDistribuirParaTransportadora(item)
                          "
                          >Distribuir p/ transportadora</v-list-item
                        >
                        <v-list-item
                          v-if="canSuspender"
                          class="pointer"
                          @click="() => suspender(item)"
                        >
                          {{
                            item.suspendido ||
                            (item.contrato_pai && item.contrato_pai.suspendido)
                              ? 'Suspensão'
                              : 'Suspender'
                          }}
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </template>

                <template v-slot:no-data>
                  <v-btn
                    v-if="canList"
                    color="primary"
                    @click="handleGetContratos(true)"
                    >Reset</v-btn
                  >
                  <div v-if="!canList">
                    <span class="red--text"
                      >Você não tem permissão para visualizar as informações
                      desta tela</span
                    >
                  </div>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item value="inativos">
              <v-card-title>
                Filtro
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headersComputed"
                :items="items"
                :server-items-length="contratos.count"
                class="border"
                :options.sync="options"
                @update:options="handleGetContratos(false)"
                :item-class="suspendido"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Contratos registrados</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-icon
                      v-if="canList"
                      medium
                      @click="handleGetContratos(false)"
                      title="Atualizar"
                      >mdi-refresh</v-icon
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-switch
                      v-model="showPesagens"
                      label="Mostrar pesagens"
                      class="pa-3 mt-5"
                    ></v-switch>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog
                      v-model="dialog"
                      max-width="1000px"
                      v-if="podeAdicionar"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="canCreate"
                          color="primary"
                          dark
                          class="mb-2"
                          v-on="on"
                          @click="adicionarContrato"
                          >Novo</v-btn
                        >
                      </template>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.data_inicio`]="{ item }">
                  {{ item.data_inicio | date2br }}
                </template>
                <template v-slot:[`item.data_fim`]="{ item }">
                  {{ item.data_fim | date2br }}
                </template>
                <template
                  v-slot:[`item.quantidade_restante_agendamento`]="{ item }"
                >
                  {{ item | quantidade_restante_agendamento }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        class="mr-2 mb-2"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div>
                        <v-list-item
                          class="pointer"
                          v-if="
                            !item.suspendido &&
                            valido &&
                            !inativo(item) &&
                            (!item.contrato_pai ||
                              (item.contrato_pai &&
                                !item.contrato_pai.suspendido))
                          "
                          @click="handleAgendar(item)"
                          >Agendar</v-list-item
                        >
                        <v-list-item class="pointer" @click="exportarCsv(item)"
                          >Exportar csv</v-list-item
                        >
                        <v-list-item
                          class="pointer"
                          @click="detalhesDistribuicao(item)"
                          >Detalhes</v-list-item
                        >
                        <v-list-item
                          v-if="canUpdate && podeEditar && !item.transportadora"
                          class="pointer"
                          @click="() => handleEditar(item)"
                          >Editar</v-list-item
                        >
                        <v-list-item
                          v-if="podeDistribuir && canDistribuirTransportadora"
                          class="pointer"
                          @click="
                            () => handleDistribuirParaTransportadora(item)
                          "
                          >Distribuir p/ transportadora</v-list-item
                        >
                        <v-list-item
                          v-if="canSuspender"
                          class="pointer"
                          @click="() => suspender(item)"
                        >
                          {{
                            item.suspendido ||
                            (item.contrato_pai && item.contrato_pai.suspendido)
                              ? 'Suspensão'
                              : 'Suspender'
                          }}
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </template>

                <template v-slot:no-data>
                  <v-btn
                    v-if="canList"
                    color="primary"
                    @click="handleGetContratos(false)"
                    >Reset</v-btn
                  >
                  <div v-if="!canList">
                    <span class="red--text"
                      >Você não tem permissão para visualizar as informações
                      desta tela</span
                    >
                  </div>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <download-excel
          v-if="canCreate"
          name="contratos.xls"
          :data="items"
          :fields="fields_excel"
        >
          <v-btn color="info" class="w-100 mt-5"> Gerar Excel </v-btn>
        </download-excel>
      </v-card-text>
    </div>
    <v-overlay :value="carregaDetalhes">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <v-dialog v-model="detalhar">
      <detalhes-programacao
        :detalhes="detalhes"
        :title="title"
        :headers="
          headersDetalhes.filter((i) => (!showPesagens ? !i.pesagem : true))
        "
        :totalPorTransportadora="totalPorTransportadora"
        :headersTotalTransportadora="
          headersTotalTransportadora.filter((i) =>
            !showPesagens ? !i.pesagem : true
          )
        "
        :download="download"
        @close="() => (detalhar = false)"
      />
    </v-dialog>
    <v-dialog v-model="dialogDeleteItem" max-width="500px">
      <v-card>
        <v-card-title>
          <v-card-text>
            <h3 class="transition-swing text-h3 mb--1 error--text">Cuidado!</h3>
            <p class="mt-8">Tem certeza que quer deletar esse contrato?</p>
          </v-card-text>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text> Cancelar </v-btn>
          <v-btn color="primary" text @click="deleteItem(contratoDelete)">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Perfil from '@/utils/perfil'
import TipoAgendamento from '@/utils/agendamento'
import {
  BasicPermissions,
  Sequences,
  CustomPermissions,
} from '@/utils/permissions'
import ExtracaoApi from '@/services/extracao/index'
import { mapActions, mapState } from 'vuex'
import Suspensao from '@/components/suspensao/suspensao.vue'
import DetalhesProgramacao from '@/components/patio/Programacao/Detalhes/DetalhesProgramacao'
import Indicadores from './Indicadores.vue'
import moment from 'moment'

import _ from 'lodash'

import { CONTRATOS, setIndicadores, saveHeaders } from '@/utils/storages'
import { toBrazilianDateTime } from '@/mixins/convertion'

const LOCAL_STORAGE_ID = CONTRATOS

export default {
  name: 'ListarContrato',
  components: { Suspensao, DetalhesProgramacao, Indicadores },
  data() {
    return {
      tab: null,
      dialog: false,
      dialog_indicadores: false,
      loading: false,
      valido: true,
      detalhes: [],
      totalPorTransportadora: [],
      title: {},
      download: {
        type: '',
        public_id: '',
      },
      detalhar: false,
      headersDetalhes: [
        {
          text: 'Veículo',
          value: 'veiculo',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Data da Cota',
          value: 'data_cota',
        },
        {
          text: 'Triado Em',
          value: 'triado_em',
        },
        {
          text: 'Liberado Em',
          value: 'saida_do_patio',
        },
        {
          text: 'Tempo em patio',
          value: 'tempo_em_patio',
        },
        {
          text: 'Finalizado Em',
          value: 'chegada_terminal',
        },
        {
          text: 'Cliente',
          value: 'cliente',
        },
        {
          text: 'Produto',
          value: 'produto',
        },
        {
          text: 'Sub Produto',
          value: 'sub_produto',
        },
        {
          text: 'Nota fiscal',
          value: 'num_nota_fiscal',
        },
        {
          text: 'Quantidade (KG)',
          value: 'quantidade',
        },
        {
          text: 'Peso Bruto (KG)',
          value: 'peso_bruto',
          pesagem: true,
        },
        {
          text: 'Peso TARA (KG)',
          value: 'peso_tara',
          pesagem: true,
        },
        {
          text: 'Peso Liquido (KG)',
          value: 'peso_liquido',
          pesagem: true,
        },
        {
          text: 'Quebra (Kg)',
          value: 'peso_quebra',
          pesagem: true,
        },
        {
          text: 'Quebra (%)',
          value: 'perc_quebra',
          pesagem: true,
        },

        {
          text: 'Embalagem',
          value: 'embalagem',
        },
        {
          text: 'Modalidade',
          value: 'modalidade',
        },
        {
          text: 'Eixos',
          value: 'eixos',
        },
      ],
      carregaDetalhes: false,
      options: {},
      search: '',
      fields_excel: {
        'Data Inicio': {
          callback: (value) => {
            let data = toBrazilianDateTime(value.data_inicio)
            return `${data}`
          },
        },
        'Data Fim': {
          callback: (value) => {
            let data = toBrazilianDateTime(value.data_fim)
            return `${data}`
          },
        },
        'Número Contrato Importação': 'numero_contrato_importacao',
        'Número Contrato': 'numero_contrato',
        Fornecedor: 'fornecedor.business_name',
        'Cidade do Fornecedor': 'fornecedor.cidade',
        'UF do Fornecedor': 'fornecedor.uf',
        Cliente: 'cliente.business_name',
        'Cidade do Cliente': 'cliente.cidade',
        'UF do Cliente': 'cliente.uf',
        'Tipo frete': 'tipoFrete.descricao',
        'Tipo Operação': 'tipo_operacao.descricao',
        Produto: 'produto.descricao',
        'Sub Produto': 'subProduto.descricao',
        Embalagem: 'embalagem.descricao',
        'Qtd. Contrato (TON)': 'quantidade',
        'Qtd. Distribuida (TON)': 'quantidade_distribuida',
        'Saldo a distribuir (TON)': 'quantidade_restante',
        'Qtd. Agendada (TON)': 'quantidade_agendada',
        'Qtd. Atendida (TON)': 'quantidade_atendida',
        'Saldo Contrato (TON)': 'quantidade_restante_agendamento',
        'Qtd. Cancelado (TON)': 'quantidade_cancelada',
        // Valor: {
        //   callback: (value) => {
        //       return `${this.numberToReal(value.valor)}`
        //   },
        // },
        // 'Forma de pagamento': 'forma_pagamento.descricao',
        // Placa: 'placa_cavalo',
        // Motorista: 'motorista',
        // Transportador: 'transportadora.business_name',
        // Terminal: 'terminal',
      },
      // "id": 1,
      //   "public_id": "16e874ae-482b-41fb-a0d3-991d3000975c",
      //   "numero_documento": "1234654",
      //   "data_inicio": "2025-06-02T14:20:16Z",
      //   "data_fim": "2025-06-23T14:20:20Z",
      //   "qt_peso": 2300,
      //   "active": true,
      //   "navio": null,
      //   "contratante": 206,
      //   "contratado": 5290,
      //   "produto": 320,
      //   "sub_produto": 2027,
      //   "tipo_operacao": 2,
      //   "terminal": 253
      headers: [
        {
          text: 'Ações',
          value: 'actions',
          sortable: false,
          habilited: true,
          block: true,
        },
        {
          text: 'Descrição',
          value: 'descricao',
          habilited: true,
          block: true,
        },
        {
          text: 'Data Inicio',
          value: 'data_inicio',
          habilited: true,
          block: true,
        },
        { text: 'Data Fim', value: 'data_fim', habilited: true, block: true },
        {
          text: 'Numero doc',
          value: 'numero_documento',
          habilited: true,
          block: true,
        },
        // {
        //   text: 'Número Pedido Importação',
        //   value: 'numero_pedido_importacao',
        //   habilited: true,
        //   block: true,
        // },
        {
          text: 'Fornecedor',
          value: 'fornecedor.business_name',
          habilited: true,
          block: true,
        },
        {
          text: 'Cliente',
          value: 'cliente.business_name',
          habilited: true,
          block: true,
        },
        {
          text: 'Navio',
          value: 'navio.descricao',
          habilited: true,
          block: true,
        },
        {
          text: 'Terminal',
          value: 'terminal.business_name',
          habilited: true,
          block: true,
        },
        {
          text: 'Produto',
          value: 'produto.descricao',
          habilited: true,
          block: true,
        },
        {
          text: 'Sub Produto',
          value: 'sub_produto.descricao',
          habilited: true,
          block: true,
        },
        {
          text: 'Qtd. (TON)',
          value: 'qt_peso',
          habilited: true,
          block: true,
        },
      ],
      headersTotalTransportadora: [
        { text: 'Transportadora', value: 'transportadora_name' },
        { text: 'Peso', value: 'peso' },
        { text: 'Performace', value: 'performace' },
        { text: 'Peso Executado', value: 'peso_liquido', pesagem: true },
        {
          text: 'Performace Executada',
          value: 'peso_liquido_performace',
          pesagem: true,
        },
      ],
      editedIndex: -1,
      editedItem: {
        descricao: '',
      },
      defaultItem: {
        descricao: '',
      },
      dialogDeleteItem: false,
      pedidoDelete: {},
      contratoSuspensao: {},
      showPesagens: false,
    }
  },
  computed: {
    ...mapState('patio', ['contratos']),
    ...mapState('auth', ['empresaAtual', 'perfilAtual']),

    headersComputed() {
      return this.headers.filter((header) => !!header.habilited)
    },
    name() {
      const date = new Date()
      const data = `${`${date.getFullYear()}`.padStart(4, 0)}-${`${
        date.getMonth() + 1
      }`.padStart(2, 0)}-${`${date.getDate()}`.padStart(
        2,
        0
      )}T${`${date.getHours()}`.padStart(
        2,
        0
      )}:${`${date.getMinutes()}`.padStart(
        2,
        0
      )}:${`${date.getSeconds()}`.padStart(
        2,
        0
      )}.${`${date.getMilliseconds()}`.padStart(3, 0)}`
      return `exportacao_pedido${data}`
    },
    permission() {
      return Sequences.Pedidos.toString()
    },

    canAgendar() {
      return this.$canDo(CustomPermissions.AGENDAR, this.permission)
    },
    canExportarCSV() {
      return this.$canDo(CustomPermissions.EXPORTAR_CSV, this.permission)
    },
    canDistribuirTransportadora() {
      return this.$canDo(
        CustomPermissions.DISTRIBUIR_TRANSPORTADORA,
        this.permission
      )
    },
    canSuspender() {
      return this.$canDo(CustomPermissions.SUSPENDER, this.permission)
    },

    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
    canCreate() {
      return this.$canDo(BasicPermissions.CADASTRAR, this.permission)
    },
    canUpdate() {
      return this.$canDo(BasicPermissions.EDITAR, this.permission)
    },
    canDelete() {
      return this.$canDo(BasicPermissions.EXCLUIR, this.permission)
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Novo' : 'Editar'
    },

    podeAdicionar() {
      return (
        this.empresaAtual.tiposContrato &&
        (this.empresaAtual.tiposContrato.includes(Perfil.Fornecedor) ||
          this.empresaAtual.gate)
      )
    },

    podeEditar() {
      return (
        this.empresaAtual.tiposContrato &&
        (this.empresaAtual.tiposContrato.includes(Perfil.Cliente) ||
          this.empresaAtual.tiposContrato.includes(Perfil.Unidade) ||
          this.empresaAtual.tiposContrato.includes(Perfil.Fornecedor))
      )
    },
    // teste
    podeDistribuir() {
      return (
        this.empresaAtual.tiposContrato &&
        this.empresaAtual.tiposContrato.includes(Perfil.Cliente)
      )
    },
    items() {
      if (this.search.length > 0) {
        return (
          this.contratos.results.filter((item) => {
            return this.headers.some((prop) => {
              try {
                const value = _.get(item, prop.value)
                return String(value)
                  .toLocaleUpperCase()
                  .includes(this.search.toLocaleUpperCase())
              } catch (error) {
                return false
              }
            })
          }) || []
        )
      }
      return this.contratos.results
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  async created() {
    this.Perfil = Perfil
    this.LOCAL_STORAGE_ID = LOCAL_STORAGE_ID
    this.headers = setIndicadores(LOCAL_STORAGE_ID, this.headers)
    if (this.canList) {
      await this.handleGetContratos(true)
    }
  },
  filters: {
    date2br(dataISO) {
      if (!dataISO) return '-'

      return moment.utc(dataISO).format('DD/MM/YYYY')
    },

    quantidade_restante_agendamento(item) {
      let restante =
        item.quantidade - item.quantidade_agendada - item.quantidade_atendida
      return parseFloat((restante > 0 ? restante : 0).toFixed(2))
    },
  },
  methods: {
    ...mapActions('patio', [
      'getContratos',
      'getContrato',
      'addContrato',
      'editContrato',
      'deleteContrato',
      'getContratosDetalhes',
    ]),
    ...mapActions('template', ['successMessage', 'errorMessage']),
    inativo(item) {
      if (new Date(item.data_fim + 'T23:59:59') < new Date()) {
        return true
      }
    },
    _saveHeaders(headers) {
      saveHeaders(LOCAL_STORAGE_ID, headers)
    },
    closeIndicadores() {
      this._saveHeaders(this.headers)
      this.dialog_indicadores = false
    },
    async detalhesDistribuicao(item) {
      try {
        console.log(item)
        this.carregaDetalhes = true
        const data = await this.getContratosDetalhes({
          public_id: item.public_id,
        })

        console.log('data', data)
        // const dataPorTransportadora = await ExtracaoApi.getPedidoDetalhePorTransportadora(
        //   {
        //     public_id: item.public_id,
        //   }
        // )

        this.totalPorTransportadora = data.transportadoras

        this.detalhes = data.agendamentos
        this.title = data.title
        if (!this.showPesagens) {
          delete this.title.total_pesagem
          delete this.title.cotas_saldo_pesagem
          delete this.title.total_pesagem_performace
          delete this.title.cotas_atendidas_quebra
          delete this.title.cotas_atendidas_quebra_perc
        }
        this.download.type = 'Contrato'
        this.download.public_id = item.public_id
        this.detalhar = true
      } catch (error) {
        console.log('-- erro ao buscar detalhes --')
        console.log(error)
        console.log('-- fim erro ao buscar detalhes --')
        this.errorMessage(
          'Erro ao buscar detalhes. Tente novamente ou contacte o suporte.'
        )
      } finally {
        this.carregaDetalhes = false
      }
    },
    suspendido(item) {
      if (item.pedido_pai && item.pedido_pai.suspendido) {
        return 'red--text'
      }
      return item.suspendido ? 'red--text' : ''
    },
    suspender(item) {
      if (item.pedido_pai && item.pedido_pai.suspendido) {
        this.contratoSuspensao = item.pedido_pai
      } else {
        this.contratoSuspensao = item
      }
      this.$nextTick(() => {
        this.$refs['suspensao'].open()
      })
    },
    async handleGetContratos(valido) {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let ordering
      if (sortBy && sortBy.length === 1 && sortDesc && sortDesc.length === 1) {
        ordering = this.options.sortBy[0]
        ordering = this.options.sortDesc[0] ? '-' + ordering : ordering
        ordering = ordering.replaceAll('.', '__')
      }
      await this.getContratos({
        proprietario: this.empresaAtual.public_id,
        pai: this.perfilAtual == Perfil.Transportadora ? false : true,
        valido: valido,
        page_size: itemsPerPage > 0 ? itemsPerPage : 1000,
        page: page,
        ordering: ordering,
        //   fornecedor: this.empresaAtual.public_id,
        //   cliente: this.empresaAtual.public_id,
        //   transportadora: this.empresaAtual.public_id
      })
      this.loading = false
    },

    adicionarContrato() {
      this.$emit('showForm')
    },

    async editItem(item) {
      const pedido = await this.getPedido(item.public_id)
      this.$emit('editItem', pedido)
    },

    prepareDeleteItem(item) {
      this.dialogDeleteItem = true
      this.pedidoDelete = item
    },

    async deleteItem(item) {
      if (item.id) {
        await this.deletePedido(item)
      } else {
        alert('Houve um problema. Tente novamente!')
        return false
      }
      this.dialogDeleteItem = false
      this.pedidoDelete = {}
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        Object.assign(this.editedItem, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        this.editPedido(this.editedItem) // REVER.. Editar
      } else {
        this.addPedido(this.editedItem)
      }
      this.close()
    },
    async exportarCsv(item) {
      try {
        console.log(item)
        const data = await ExtracaoApi.getExportCsvPedidos({
          public_id: item.public_id,
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.name + '.csv') //or any other extension
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        if (error.response) {
          this.errorMessage(error.response.data)
          return
        }
        if (error.message) {
          this.errorMessage(error.message)
          return
        }
        this.errorMessage(error)
      }
    },
    handleAgendar(item) {
      this.$router.push({
        // name: 'Agendamentos',
        name: 'NovoAgendamento',
        params: {
          pedidoSelecionado: item,
          tipoAgendamento: TipoAgendamento.DoPedido,
        },
      })
    },

    async handleEditar(item) {
      const contrato = await this.getContrato(item.public_id)
      contrato.quantidade_usada =
        contrato.quantidade - contrato.quantidade_restante
      this.$emit('editar', contrato)
    },

    async handleDistribuirParaTransportadora(item) {
      const pedido = await this.getPedido(item.public_id)
      pedido.replicacoes = pedido.pedidos.map((item) => {
        return {
          public_id: item.public_id,
          cadencia_livre: item.cadencia_livre,
          numero_pedido: item.numero_pedido,
          quantidade: item.quantidade,
          terminal: item.terminal.public_id,
          transportadora: item.transportadora.public_id,
          to: item.transportadora.public_id,
          suspendido: item.suspendido == true,
          suspensoes: item.suspensoes,
        }
      })
      this.$emit('distribuirParaTransportadora', pedido)
    },
    handleRelatorio(item) {
      item.quantidade_usada = item.quantidade - item.quantidade_restante
      this.$emit('showRelatorio', item)
    },
  },
}
</script>
